module.exports = __webpack_public_path__ + "site/img/money.46a13584.png";